import { Fragment } from 'react'
import Name from './name'

const Inner = ({ name, color = 'primary' }) => {
  const base = ''
  const bgColor = {
    primary: 'bg-dune',
    secondary: 'bg-khaki',
  }

  return (
    <Fragment>
      {/* ENTER */}
      <div
        className={`absolute top-0 left-0 w-[100%] translate-x-[-140%] group-hover:translate-x-0 h-full transition-all group-hover:duration-600 duration-0 pointer-events-none inner ${base} ${bgColor[color]}`}
      >
        <div
          className={`absolute top-0 right-0 h-full aspect-1/2 rounded-r-full translate-x-full ${bgColor[color]}`}
        />
      </div>
      {/* EXIT */}
      <div
        className={`absolute top-0 right-0 w-[100%] group-hover:translate-x-0 translate-x-[140%] h-full transition-all group-hover:duration-0 group-hover:delay-600 duration-600 delay-0 pointer-events-none inner ${base} ${bgColor[color]}`}
      >
        <div
          className={`absolute top-0 left-0 h-full aspect-1/2 rounded-l-full -translate-x-full ${bgColor[color]}`}
        />
      </div>
      <Name name={name} />
    </Fragment>
  )
}

export default Inner
